/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureResourceBatchRequest {
    getFixupPrototypeFunction() { return TagPostureResourceBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<TagPostureResourceBatchRequest>): TagPostureResourceBatchRequest {
        let obj = Object.assign(new TagPostureResourceBatchRequest(), model);
        TagPostureResourceBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureResourceBatchRequest>): TagPostureResourceBatchRequest {
        if (!model) return null;
        return TagPostureResourceBatchRequest.newInstance(<TagPostureResourceBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureResourceBatchRequest) {
        if (!obj) return;

        models.TagPostureResourceBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureResourceBatchRequest): boolean {
        Object.setPrototypeOf(obj, TagPostureResourceBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Baseline to fetch summary for (all if missing)
     */
    baseline_id: string;

    /**
     * List of resource ids to fetch Tag Posture Details
     */
    resource_ids: Array<string>;

}
